







































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeLabSupervisi } from "@/store/modules/LabSupervisiStore";
import LabSupervisiSvc from "@/services/LabSupervisiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import LabSeksiChecklist from "./LabSeksiChecklist.vue";
import LabRingkasanPanel from "./LabRingkasanPanel.vue";

@Component({
  components: { LabSeksiChecklist, LabRingkasanPanel }
})
export default class LabSupervisiForm extends Vue {
  @Prop({ default: null }) sessionData!: any;

  storeModule = storeLabSupervisi;
  session: any = null;
  currentStep = 1;
  saving = false;
  signing = false;
  showSignDialog = false;
  signPassword = "";

  form: any = {
    tanggal_supervisi: moment().format("YYYY-MM-DD"),
    waktu_mulai: moment().format("HH:mm"),
    waktu_selesai: "",
    kepala_unit_nama: "",
    ka_instalasi_id: null,
    unit_lab: null,
    temuan_utama: "",
    rencana_tindak_lanjut: "",
  };

  allItems: any[] = [];

  rules = {
    required: (v: any) => !!v || "Wajib diisi",
  };

  unitLabOptions = [
    { text: "Patologi Klinik", value: "patologi_klinik" },
    { text: "Patologi Anatomi", value: "patologi_anatomi" },
    { text: "Mikrobiologi", value: "mikrobiologi" },
    { text: "Bank Darah", value: "bank_darah" },
  ];

  seksiList = [
    { seksi: "pengelolaan_limbah", label: "I. Supervisi Pengelolaan Limbah", shortLabel: "I. Limbah" },
    { seksi: "fasilitas_kebersihan", label: "II. Supervisi Fasilitas dan Kebersihan", shortLabel: "II. Fasilitas" },
    { seksi: "kepatuhan_petugas", label: "III. Kepatuhan Petugas HH & APD", shortLabel: "III. Kepatuhan" },
  ];

  async mounted() {
    // Load definitions
    await this.storeModule.loadDefinitions();
    this.initItems();

    // If editing
    if (this.sessionData?.id) {
      await this.storeModule.loadDetail(this.sessionData.id);
      this.session = this.storeModule.currentSession;
      this.populateForm();
    }
  }

  initItems() {
    const defs = this.storeModule.definitions || [];
    this.allItems = defs.map((def: any) => ({
      definition_id: def.id,
      kode_item: def.kode_item,
      seksi: def.seksi,
      urutan: def.urutan,
      komponen_supervisi: def.komponen_supervisi,
      tipe_jawaban: def.tipe_jawaban,
      nilai_target_min: def.nilai_target_min,
      nilai_target_max: def.nilai_target_max,
      kritikal: def.kritikal,
      display_no: this.getDisplayNo(def),
      // Answer fields
      hasil: null,
      nilai_numeric: null,
      masalah: "",
      rekomendasi: "",
      foto_bukti: [],
    }));
  }

  getDisplayNo(def: any) {
    const kode = def.kode_item || "";
    const parts = kode.split("-");
    return parts[parts.length - 1] || "";
  }

  populateForm() {
    if (!this.session) return;
    const s = this.session;
    this.form = {
      tanggal_supervisi: s.tanggal_supervisi ? moment(s.tanggal_supervisi).format("YYYY-MM-DD") : "",
      waktu_mulai: s.waktu_mulai || "",
      waktu_selesai: s.waktu_selesai || "",
      kepala_unit_nama: s.kepala_unit_nama || "",
      ka_instalasi_id: s.ka_instalasi_id,
      unit_lab: s.unit_lab || null,
      temuan_utama: s.temuan_utama || "",
      rencana_tindak_lanjut: s.rencana_tindak_lanjut || "",
    };

    // Populate items from session items
    if (s.items && s.items.length > 0) {
      for (const savedItem of s.items) {
        const local = this.allItems.find((i: any) => i.definition_id === savedItem.definition_id);
        if (local) {
          local.hasil = savedItem.hasil;
          local.nilai_numeric = savedItem.nilai_numeric;
          local.masalah = savedItem.masalah || "";
          local.rekomendasi = savedItem.rekomendasi || "";
          local.foto_bukti = savedItem.foto_bukti || [];
        }
      }
    }
  }

  getItemsBySeksi(seksi: string) {
    return this.allItems
      .filter((i: any) => i.seksi === seksi)
      .sort((a: any, b: any) => a.urutan - b.urutan);
  }

  /** Seksi punya temuan (naratif) — penanda pada stepper. */
  hasSeksiTemuan(seksi: string) {
    return this.getItemsBySeksi(seksi).some(
      (i: any) => i.masalah && String(i.masalah).trim() !== ""
    );
  }

  onItemsChange() {
    // Items are reactive, no extra action needed
  }

  onFormUpdate(updatedForm: any) {
    Object.assign(this.form, updatedForm);
  }

  buildPayload() {
    return {
      ...this.form,
      items: this.allItems.map((i: any) => ({
        definition_id: i.definition_id,
        hasil: i.hasil,
        nilai_numeric: i.tipe_jawaban === "numeric_range" ? i.nilai_numeric : null,
        masalah: i.masalah || null,
        rekomendasi: i.rekomendasi || null,
        foto_bukti: i.foto_bukti?.length > 0 ? i.foto_bukti : null,
      })),
    };
  }

  async simpanDraft() {
    if (!(this.$refs.formHeader as any).validate()) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.session?.id) {
        resp = await LabSupervisiSvc.update(this.session.id, payload);
      } else {
        resp = await LabSupervisiSvc.create(payload);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Draft berhasil disimpan");
        this.session = resp.data.data;
        this.$emit("saved");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async submitAndSign() {
    if (!(this.$refs.formHeader as any).validate()) return;

    // Naratif: tidak ada kewajiban ya/tidak per item — temuan/rekomendasi opsional.
    // First submit data
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.session?.id) {
        resp = await LabSupervisiSvc.submit(this.session.id, payload);
      } else {
        // Create first, then submit
        resp = await LabSupervisiSvc.create(payload);
        if (resp?.data?.status == "1") {
          this.session = resp.data.data;
          resp = await LabSupervisiSvc.submit(this.session.id, payload);
        }
      }
      if (resp?.data?.status == "1") {
        this.session = resp.data.data;
        this.showSignDialog = true;
      }
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async doSign() {
    if (!this.signPassword) {
      appModule.NoticeDelay("Password wajib diisi");
      return;
    }
    this.signing = true;
    try {
      const resp = await LabSupervisiSvc.signSupervisor(this.session.id, {
        password: this.signPassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menandatangani. Menunggu acknowledge Ka. Instalasi Lab.");
        this.showSignDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.signing = false;
  }
}
